<script setup lang="ts"></script>

<template>
  <q-page-container style="background-color: #f8fafc">
    <router-view />
  </q-page-container>
</template>
